import React from 'react';

const Footer: React.FC = () => {
    return (
        <footer className="footer">
            <div className="container text-justify">
                <p><b>nicalcoca@gmail.com</b></p>
            </div>
        </footer>
    );
};

export default Footer;
